import { Pagination } from "@mui/material";
import {
  CalendarIcon,
  CheckCircledIcon,
  Cross2Icon,
  CrossCircledIcon,
  PersonIcon,
  SewingPinFilledIcon,
  UploadIcon,
} from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import toast from "react-hot-toast";
import {
  checkTagValidity,
  getUserProfil,
  months,
  years,
} from "../../Utils/Utils";
import {
  BASE_URL,
  CHARGER_FICHIER_PROVISIONING,
  EXPORT_PROVISIONING_EN_ATTENTE,
  EXPORT_RAPPORT,
  LISTE_PROVISIONING,
} from "../../Utils/constant";
import { Abonnement } from "../../components/Abonnement/Abonnement";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { Pbo } from "../../components/Widget/Pbo";
import { Tabs } from "../../components/Widget/Tab";
import { store } from "../../services/service";
import { useStoreLivraison } from "../../store/livraisonStore";

const Provisioning = () => {
  const [isSubmit, setIsSubmit] = useState(false);
  const [message, setMessage] = useState("");
  const [fichier, setFichier] = useState([]);
  const [isLoad, setIsload] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [select, setSelect] = useState("ANNEE");
  const [active, setActive] = useState({
    index: 0,
    value: "En attente de provisioning",
    tag: "EN_ATTENTE_PROVISIONING",
  });

  const listeTabsData = [
    {
      index: 0,
      value: "En attente de provisioning",
      tag: "LISTE_EN_ATTENTE_PROVISIONING",
    },
    {
      index: 1,
      value: "Liste de provisioning",
      tag: "LISTE_PROVISIONING",
    },
  ];

  const filteredTabsData = listeTabsData
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0]);
    }
  }, []);

  const handleDownload = () => {
    const user = getUserProfil();
    setIsload(true);
    fetch(
      `${
        BASE_URL +
        (active.index === 0 ? EXPORT_PROVISIONING_EN_ATTENTE : EXPORT_RAPPORT)
      }?model=${
        active.index === 0 ? "EN_ATTENTE_PROVISIONING" : "PROVISIONING"
      }&username=${user?.username}${
        active.index === 1
          ? `&dateDebut=${dateRange[0]
              ?.toLocaleDateString()
              .replace(/\//g, "-")}&dateFin=${dateRange[1]
              ?.toLocaleDateString()
              .replace(/\//g, "-")}`
          : ""
      }`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      }
    )
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download =
          active.index === 0
            ? "en_atttente_provisioning.xlsx"
            : `Provisioning.xlsx`;
        document.body.appendChild(a);
        a.click();
        setIsload(false);
      })
      .catch((err) => setIsload(false));
  };

  const handleChangeFichier = (e) => {
    const selectedFiles = e.target.files;
    const newFiles = Array.from(selectedFiles);
    setFichier((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const more = (page) => {
    provisioningStore.getData(
      LISTE_PROVISIONING,
      { page: page - 1, param: "", size: 10 },
      "&periode=&mois=&annee=&dateDebut=&dateFin="
    );
  };

  const provisioningStore = useStoreLivraison();
  useEffect(() => {
    provisioningStore.getData(
      LISTE_PROVISIONING,
      { page: 0, param: "", size: 10 },
      "&periode=&mois=&annee=&dateDebut=&dateFin=&resultat=OK"
    );
  }, [isSubmit]);

  return (
    <div className="">
      <div className="lg:flex gap-8 items-center ">
        <h3 class="text-3xl font-bold font-mtn">Provisioning</h3>
        <div className="ml-auto lg:flex gap-x-3">
          <select
            onChange={(e) => {
              setSelect(e.target.value);
            }}
            className="my-2 select"
          >
            <option>Periode</option>
            <option value="MOIS">Filtre par mois</option>
            <option value="ANNEE" selected>
              Filtre par années
            </option>
          </select>
          {select === "MOIS" ? (
            <select onChange={(e) => {}} className="my-2 select">
              <option disabled selected>
                mois
              </option>
              {months.map((item) => (
                <option value={item.code}>{item.name}</option>
              ))}
            </select>
          ) : select === "ANNEE" ? (
            <select onChange={(e) => {}} className="my-2 select ">
              <option disabled selected>
                années
              </option>
              {years.map((item) => (
                <option
                  value={item.name}
                  selected={
                    new Date().getFullYear() === Number(item.name)
                      ? true
                      : false
                  }
                >
                  {item.name}
                </option>
              ))}
            </select>
          ) : (
            <ReactDatePicker
              dateFormat="dd-MM-yyyy"
              selected={startDate}
              onChange={(update) => {
                if (update[1] != null) {
                }
                setDateRange(update);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              className="text-xs font-normal cursor-pointer btn btn-sm hover:bg-gray-100 text-center h-8 my-2 w-52 rounded-md border border-input bg-gray-100 px-3 py-1 shadow-sm"
            />
          )}
        </div>
      </div>
      {filteredTabsData.length !== 0 ? (
        <Tabs
          tabsData={filteredTabsData}
          active={active}
          setActive={setActive}
        />
      ) : null}
      <div className="bg-white rounded-md px-2 py-4 mt-3">
        {active.index === 0 ? (
          <>
            <div>
              <button
                disabled={isLoad}
                className="my-2 btn btn-sm bg-main text-black"
                onClick={handleDownload}
              >
                {!isLoad ? "Exporter" : "... Exportation encours"}
              </button>

              <button
                onClick={() => document.getElementById("upload").showModal()}
                className="btn btn-sm bg-black text-white"
              >
                Charger un fichier
              </button>

              <dialog id="upload" className="modal rounded-none">
                <div className="modal-box w-10/12 max-w-xl">
                  <div className="modal-action">
                    <h1 className="font-mtn mr-auto text-2xl font-bold">
                      Charger un fichier
                    </h1>
                    <form method="dialog">
                      <button id="close_upload" className="btn btn-sm">
                        <Cross2Icon />
                      </button>
                    </form>
                  </div>
                  <div>
                    <p className="text-xs text-red-600">{message}</p>
                    <label className="form-contro w-full">
                      <div className="label flex flex-col justify-start items-start gap-1.5">
                        <span className="label-text  font-medium text-gray-400"></span>
                        <div className="w-full">
                          <div className="text-black py-8 border-dashed border bg-gray-50 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm ">
                            <div className="flex justify-center mb-3">
                              <UploadIcon />
                            </div>

                            <p className="text-center text-sm">
                              {fichier.length !== 0 ? "" : "Charger le fichier"}
                            </p>
                            <div className="flex justify-center">
                              <input
                                className="text-sm mx-auto file-input-bordered mb-3 file-input file-input-ghost w-full max-w-xs"
                                type="file"
                                id="fichier"
                                onChange={handleChangeFichier}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </label>
                    {/* <a
                      href={model}
                      download="modelAbonnement"
                      className="btn text-white bg-black btn-sm mx-1"
                    >
                      Telecharger le model
                    </a> */}
                    <button
                      onClick={() => {
                        setIsSubmit(true);
                        store(
                          CHARGER_FICHIER_PROVISIONING,
                          "multipart/form-data",
                          {
                            fichier: fichier[0],
                          }
                        )
                          .then((res) => {
                            if (res.status === 200) {
                              setIsSubmit(null);
                              provisioningStore.getData(
                                LISTE_PROVISIONING,
                                { page: 0, param: "", size: 10 },
                                "&periode=&mois=&annee=&dateDebut=&dateFin=&resultat=OK"
                              );
                              document.getElementById("close_upload").click();
                              toast.success("Fichier chargé avec succès");
                            }
                          })
                          .catch((err) => {
                            setIsSubmit(false);
                            setMessage(err?.response?.data?.donnee);
                          });
                      }}
                      disabled={
                        isSubmit ? true : fichier.length === 0 ? true : false
                      }
                      className="font-mtn bg-main btn btn-sm"
                    >
                      charger le fichier
                    </button>
                  </div>
                </div>
              </dialog>
            </div>

            <Abonnement
              status={"EN_ATTENTE_DE_PROVISIONING"}
              step={13}
              perm={""}
            />
          </>
        ) : active.index === 1 ? (
          <>
            <div>
              <div className="my-3 space-x-1">
                <input
                  onChange={(e) => {
                    provisioningStore.getData(
                      LISTE_PROVISIONING,
                      { page: 0, param: e.target.value, size: 10 },
                      `&periode=&mois=&annee=&dateDebut=&dateFin=&resultat=OK`
                    );
                  }}
                  type="text"
                  placeholder="Rechercher element..."
                  className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                />
                <button
                  className="btn btn-sm bg-main text-black"
                  onClick={() => document.getElementById("rapport").showModal()}
                >
                  Exporter
                </button>

                <dialog id="rapport" className="modal bg-slate-900/70">
                  <div className="modal-box w-full lg:w-96 h-60 overflow-visible">
                    <div className="flex items-center justify-between p-3">
                      <div className="">
                        <h2 className="font-mtn font-extrabold flex flex-row items-center text-lg mb-8 text-[#000000a8]">
                          Telechargement de rapport
                        </h2>
                      </div>
                      <form method="dialog">
                        <button
                          // onClick={() => setSubmit(null)}
                          id="fermer_create_trajet"
                          className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                        >
                          ✕
                        </button>
                      </form>
                    </div>
                    <div>
                      <p className="text-xs">Selectionnez une période</p>
                      <div className="flex items-center gap-2">
                        <ReactDatePicker
                          dateFormat="dd-MM-yyyy"
                          selected={startDate}
                          onChange={(update) => {
                            setDateRange(update);
                          }}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange
                          popperClassName="z-[9999]"
                          className="z-[9999] text-xs font-normal cursor-pointer text-center h-10 my-2 w-full lg:w-60 rounded-lg border-2 border-input px-3 py-1"
                        />
                        <button
                          disabled={isLoad}
                          onClick={handleDownload}
                          className="px-4 py-2 rounded-lg bg-main h-10 text-xs"
                        >
                          {!isLoad ? "Exporter" : "...encours"}
                        </button>
                      </div>
                    </div>
                  </div>
                </dialog>
              </div>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-2 my-4">
                {provisioningStore?.data?.data?.length === 0 ? (
                  <div className="flex justify-center items-center">
                    <img src="" alt="" srcset="" />
                  </div>
                ) : provisioningStore?.data?.data?.length !== 0 &&
                  !provisioningStore?.loading ? (
                  provisioningStore?.data?.data?.map((item) => (
                    <div className="relative bg-white rounded-xl border-slate-200 border shadow-sm">
                      <dialog
                        id={`show${item.id}`}
                        className="modal bg-slate-900/70"
                      >
                        <div className="relative modal-box">
                          <div className="flex items-center justify-between p-3">
                            <div className="flex flex-row gap-2"></div>
                            <form method="dialog">
                              <button
                                id="fermer_create_trajet"
                                className="absolute top-4 right-4"
                              >
                                ✕
                              </button>
                            </form>
                          </div>
                          <div>
                            <div className="">
                              <div className="bg-white p-3 rounded-lg">
                                <div className="">
                                  <h3 className="font-mtn lg:text-lg text-2xl text-amber-500 font-bold">
                                    Ticket N°
                                    {
                                      item?.abonnement?.eligibilite
                                        ?.numeroTicket
                                    }
                                  </h3>
                                </div>
                                <div className="mt-3 border-t border-dashed border-amber-300">
                                  <dl className="divide-y divide-gray-100">
                                    <div className="py-3 ">
                                      <dt className="text-sm text-gray-500">
                                        Client
                                      </dt>
                                      <dd className="mt-1 text-sm font-medium leading-6  ">
                                        {item?.abonnement?.client?.nomPrenoms}
                                      </dd>
                                    </div>

                                    <div className="py-3">
                                      <dt className="text-sm leading-6 text-gray-500">
                                        Email
                                      </dt>
                                      <dd className="mt-1 text-sm font-medium leading-6  ">
                                        {item?.abonnement?.client?.email}
                                      </dd>
                                    </div>
                                    <div className="py-3 ">
                                      <dt className="text-sm  leading-6 text-gray-500">
                                        Contact client
                                      </dt>
                                      <dd className="mt-1 text-sm font-medium leading-6 ">
                                        {item?.abonnement?.client?.numero}
                                      </dd>
                                    </div>
                                    <div className="py-3 ">
                                      <dt className="text-sm  leading-6 text-gray-500">
                                        Numero avantage
                                      </dt>
                                      <dd className="mt-1 text-sm font-medium leading-6 ">
                                        {item?.abonnement?.numeroMtn}
                                      </dd>
                                    </div>
                                    <div className="py-3 ">
                                      <dt className="text-sm  leading-6 text-gray-500">
                                        Ville du client
                                      </dt>
                                      <dd className="mt-1 text-sm font-medium leading-6 ">
                                        {
                                          item?.abonnement?.domicile?.quartier
                                            ?.commune?.designation
                                        }
                                      </dd>
                                    </div>
                                    <div className="py-3 ">
                                      <dt className="text-sm  leading-6 text-gray-500">
                                        Quartier
                                      </dt>
                                      <dd className="mt-1 text-sm font-medium leading-6">
                                        {
                                          item?.abonnement?.domicile?.quartier
                                            ?.designation
                                        }
                                      </dd>
                                    </div>

                                    <div className="py-3 ">
                                      <dt className="text-sm  leading-6 text-gray-500">
                                        Status d'éligibilité
                                      </dt>
                                      <dd className="mt-1 text-sm leading-6 font-medium text-amber-600 ">
                                        {item?.abonnement?.eligibilite
                                          ?.ftthEligible === "yes"
                                          ? "Eligible"
                                          : "Pas eligible"}
                                      </dd>
                                    </div>

                                    <div className="py-3 ">
                                      <dt className="text-sm  leading-6 text-gray-500">
                                        Forfait souhaité
                                      </dt>
                                      <dd className="mt-1 text-sm leading-6 text-amber-500 ">
                                        {item?.abonnement?.forfait?.designation}
                                      </dd>
                                    </div>
                                  </dl>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </dialog>
                      <div className="rounded-t-xl flex items-center gap-3 border-b-[2px] border-orange-100 px-2 py-3">
                        <p className="text-[12px] font-semibold">
                          {item?.abonnement?.eligibilite?.numeroTicket}
                        </p>
                        <div className="ml-auto flex items-center gap-2">
                          <div
                            className={`w-fit flex gap-1 px-3 border  rounded-full py-1 text-xs   font-semibold`}
                          >
                            {item.resultat === "OK" ? (
                              <CheckCircledIcon className="ml-auto bg-green-600 w-4 h-4 rounded-full text-white" />
                            ) : item.resultat === "NON_OK" ? (
                              <CrossCircledIcon className="bg-red-600 w-4 h-4 rounded-full text-white" />
                            ) : null}
                          </div>
                          <div
                            className={` px-1 border  rounded-full py-[2px] text-xs ${
                              item?.abonnement?.statusConfirmation ===
                              "CONFIRMER"
                                ? "text-green-600"
                                : "text-gray-500"
                            }  font-semibold`}
                          >
                            {item?.abonnement.statusConfirmation?.toLowerCase()}
                          </div>
                        </div>
                      </div>
                      <div className="px-3 py-2">
                        <div className="my-1 flex items-center">
                          <div className="flex items-center gap-2">
                            <Pbo
                              pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                              port={item?.brin}
                            />
                          </div>
                        </div>
                        <h1 className="text-xs flex gap-1 items-center my-2">
                          Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                          {item?.abonnement?.forfait?.categorie
                            ?.replace("_", "")
                            .toLowerCase()}
                        </h1>
                        <div className=" gap-1 ">
                          <div>
                            <p className="text-[13px] font-medium">
                              Numero FTTH : {item?.abonnement?.numeroFtth}
                            </p>
                            {/* <p className="text-xs flex font-semibold gap-2">
                              SN : <span>{item?.abonnement?.numeroSerie}</span>
                            </p> */}
                          </div>
                        </div>
                        <div className="items-center gap-2 space-y-3">
                          <h1 className="text-[14px] font-bold flex items-center">
                            <SewingPinFilledIcon />
                            {item?.abonnement?.domicile?.quartier.commune
                              .designation +
                              ", " +
                              item?.abonnement?.domicile?.quartier?.designation}
                          </h1>
                          <div className="pb-3 border-b flex gap-4 items-center">
                            <p className="text-xs flex gap-1 items-center font-medium">
                              <CalendarIcon /> Date de provisioning :
                              {" " + item?.dateCtration
                                ? new Date(item?.dateCtration).toLocaleString()
                                : "--"}
                            </p>
                          </div>
                          <div className="flex gap-1 ">
                            <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                            <div>
                              <p className="text-[13px] font-medium">
                                {item?.abonnement.client?.nomPrenoms}
                              </p>
                              <p className="text-xs flex font-semibold gap-2">
                                <span>{item?.abonnement.client?.numero}</span>{" "}
                                {" | "}{" "}
                                <span>{item?.abonnement.client?.email}</span>{" "}
                              </p>
                            </div>
                          </div>

                          <button
                            onClick={() => {
                              document
                                .getElementById(`show${item.id}`)
                                .showModal();
                            }}
                            className="btn btn-sm text-amber-500 border-none shadow-none bg-amber-100 text-xs"
                          >
                            Voir le provisioning
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <ContentLoading />
                )}
              </div>
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => more(newValue)}
                onSelect={(selectedPage) => more(selectedPage)}
                count={provisioningStore?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Provisioning;
